(function() {
    angular.module('UndergroundWebApp').constant('appVersion', '22.11.0.1020');
})();
